import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from "react";
import cn from "clsx";
import { CrehanaForBusiness } from "@crehana/icons/logos";
import { jsx as _jsx } from "react/jsx-runtime";
var OrganizationLogoImage = function OrganizationLogoImage(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    style = _ref.style,
    colors = _ref.colors,
    className = _ref.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    is404Image = _useState2[0],
    setIs404Image = _useState2[1];

  /**
   * This is a workaround to avoid render a broken image
   */
  var handleImageError = function handleImageError() {
    return setIs404Image(true);
  };
  if (is404Image) {
    return /*#__PURE__*/_jsx(CrehanaForBusiness, {
      size: 18,
      "aria-hidden": true,
      color: colors === null || colors === void 0 ? void 0 : colors.primary,
      secondaryColor: colors === null || colors === void 0 ? void 0 : colors.secondary,
      className: className
    });
  }
  return /*#__PURE__*/_jsx("img", {
    src: src,
    alt: alt,
    "aria-hidden": true,
    style: style,
    className: cn('h-24', className),
    onError: handleImageError
  });
};
export default OrganizationLogoImage;